<template>
    <button
        @click="handleAddToCart"
        :class="[
            'px-6 py-3 rounded-lg font-semibold transition-colors',
            primary ? 'bg-[var(--primary-400)] hover:bg-[var(--primary-700)] text-white' : 'bg-neutral-200 hover:bg-neutral-300 dark:bg-neutral-700 dark:hover:bg-neutral-600 text-neutral-900 dark:text-white',
            size === 'sm' ? 'text-sm px-4 py-2' : '',
            size === 'lg' ? 'text-lg px-8 py-4' : '',
            block ? 'w-full' : '',
        ]"
    >
        <slot>{{ buttonText }}</slot>
    </button>
</template>

<script>
import { cartStore } from '../store/cart';
import { trackAddToCart } from '../utils/analytics';

export default {
    name: 'AddToCartButton',
    props: {
        product: {
            type: Object,
            required: true,
            validator: (value) => {
                return value.id && value.name && value.price !== undefined;
            },
        },
        primary: {
            type: Boolean,
            default: true,
        },
        size: {
            type: String,
            default: 'md',
            validator: (value) => ['sm', 'md', 'lg'].includes(value),
        },
        block: {
            type: Boolean,
            default: false,
        },
        buttonText: {
            type: String,
            default: 'Add to Cart',
        },
    },
    methods: {
        handleAddToCart() {
            // Track analytics event
            trackAddToCart(this.product);

            // Add to cart
            cartStore.addItem(this.product);
        },
    },
};
</script>

<style scoped>
</style>

